import { createSlice } from '@reduxjs/toolkit'
import { UsersState } from './users.interface'
import {
  deleteUserAccount,
  editUserAccount,
  getUsersAccounts,
  createUserAccount,
  verifyUserAccount,
  getOrganizationUsersAccounts,
  getPendingUsersAccounts
} from '@/store/actions/users.actions'
import { logoutUser } from '@/store/actions/auth.actions'

const initialState: UsersState = {
  pendingUsers: {
    data: [],
    count: 0
  },
  users: {
    data: [],
    count: 0
  },
  user: null,
  usersError: null
}

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers(state, action) {
      state.users = action.payload
    },
    setPendingUsers(state, action) {
      state.pendingUsers = action.payload
    },
    setUsersError(state, action) {
      state.usersError = action.payload
    },
    clearUsersError(state) {
      state.usersError = null
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getUsersAccounts.fulfilled, (state, action) => {
        state.users = action.payload
      })
      .addCase(getPendingUsersAccounts.fulfilled, (state, action) => {
        state.pendingUsers = action.payload
      })
      .addCase(createUserAccount.fulfilled, (state, action) => {
        state.users = action.payload
      })
      .addCase(editUserAccount.fulfilled, (state, action) => {
        state.users = action.payload
      })
      .addCase(deleteUserAccount.fulfilled, (state, action) => {
        state.users = action.payload
      })
      .addCase(verifyUserAccount.fulfilled, (state, action) => {
        state.users = action.payload
      })
      .addCase(getOrganizationUsersAccounts.fulfilled, (state, action) => {
        state.users = action.payload
      })
      .addCase(logoutUser.fulfilled, () => initialState)
  }
})

export const { setUsers, setUsersError, clearUsersError, setPendingUsers } = usersSlice.actions

export default usersSlice.reducer
